import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
    <g transform="translate(4.16 3.12)">
      <path d="M9.36 0a9.36 9.36 0 110 18.72A9.36 9.36 0 019.36 0zm0 1.872a7.459 7.459 0 00-3.225.728l-.968 2.844-2.193.003A7.453 7.453 0 001.872 9.36c0 .716.1 1.409.288 2.064l3.288 2.178-.686 1.668a7.456 7.456 0 005.237 1.551l2.227-1.971 1.052.893a7.5 7.5 0 003.36-4.614l-1.447-2.89 1.364-.961a7.49 7.49 0 00-2.242-3.534h-3.475l-.428-1.799a7.553 7.553 0 00-1.05-.073zm-.168 3.744l3.4 2.47-1.299 3.998H7.09L5.79 8.087l3.4-2.471z" />
    </g>
  </svg>
);

const IconScored = (props: IIcon & ReactProps) => <Icon {...props} svg={svg} />;

export default IconScored;
